import config from "@config";
import { loadLanguageAsync } from "@storefront/core/i18n";
import { Logger } from "@storefront/core/lib/logger";
import {
  cleanPath,
  cleanFullPath,
  extractFilters,
} from "@storefront/core/router/helpers/cleanPath.js";
// import { router } from "@/main";
import { urlRoute } from "@storefront/core/data-resolver/url";
// import store from "@/store";

export async function beforeEachGuard(to, from, next, router, store) {
  //check language
  let lang = "";
  const split = to.path.split("/");
  if (config.languages.available.includes(split[1])) {
    lang = await loadLanguageAsync(split[1]).catch((e) => {
      Logger.error("loadLanguageAsync1", "beforeEachGuard", e)();
      throw e;
    });
  } else {
    lang = await loadLanguageAsync(config.languages.default).catch((e) => {
      Logger.error("loadLanguageAsync2", "beforeEachGuard", e)();
      throw e;
    });
  }
  const path = cleanPath(to); /// remove lang
  const fullpath = cleanFullPath(to); // Replace any occurrences of "//" with "/"
  //let resolve = null;

  if (to.path === from.path) return next();
  let newRoute = path;
  let newFilter = [];
  if (path && path.indexOf(":") != -1) {
    let routeParts = path.split("/");
    if (routeParts) {
      let splitIndex = 0;
      routeParts.forEach((part, index) => {
        if (splitIndex > 0) {
          return;
        }
        if (part.indexOf(":") != -1) {
          splitIndex = index;
          return false;
        }
      });
      newRoute = routeParts.slice(0, splitIndex).join("/");
      if (config.use_slash_endings) {
        newRoute = newRoute + "/";
      }
      newRoute = newRoute.charAt(0) == "/" ? newRoute.slice(1) : newRoute;
      const filter_name = "/" + config.filter_name + "/";
      if (filter_name && newRoute.slice(-filter_name.length) == filter_name) {
        newRoute = newRoute.slice(0, -filter_name.length);
      }
      if (newRoute.endsWith("/f")) {
        newRoute = newRoute.slice(0, -2);
      }
      let filterArr = routeParts.slice(splitIndex);
      filterArr.forEach((el) => {
        if (el !== "") {
          newFilter.push(el);
        }
      });
    }
  }
  const resolve = await urlRoute(newRoute).catch((e) => {
    Logger.error("urlResolver", "beforeEachGuard", e)();
    throw e;
  });

  if (resolve != null) {
    //Load the information per type of route
    switch (resolve.type) {
      case "CATEGORY": {
        let load = true;
        const obj = store.getters["category/getCurrentCategory"];
        if (obj != null && obj.id == resolve.id) {
          load = false;
        }
        if (load) {
          newFilter.category = resolve.id;
          const filter = await extractFilters(to, newFilter, store);
          store.dispatch("category/setCategory", {
            category: resolve,
            filter: filter,
            store: store
          });
        }
        break;
      }
      case "PRODUCT": {
        let load = true;
        const obj = store.getters["product/getCurrentProduct"];
        if (obj != null) {
          if (obj.sku == resolve.sku) {
            load = false;
          }
        }
        if (load) {
          await store
            .dispatch("product/loadWithSku", {
              sku: resolve.sku,
              store,
            })
            .catch((e) => {
              Logger.error("product/loadWithSku", "beforeEachGuard", e)();
              throw e;
            });
        }
        break;
      }
      case "CMS_PAGE": {
        store.dispatch("cmsPage/setPage", {
          page: resolve,
        });

        break;
      }
      case "LANDING_PAGE": {
        store.dispatch("landingPage/getMeta", {
          meta: resolve,
        });

        break;
      }
    }
  }

  if (to.matched.length === 0) {
    const testRoute = router.options.routes.find((e) => {
      if (e.path === path) {
        return true;
      }
    });
    if (testRoute != null) {
      router.addRoute({
        path: to.path,
        component: testRoute.component,
      });
      // next(to.fullPath);
      next(fullpath);
      return;
    }
    if (resolve != null) {
      let route = false;
      switch (resolve.type) {
        case "CATEGORY": {
          const testPage = router.options.routes.find((e) => e.name === "category-page");
          if (testPage != null) {
            route = {
              name: "category-" + lang + "-" + path.replace("/", "-"),
              path: to.path,
              component: testPage.component,
            };
          }
          break;
        }
        case "PRODUCT": {
          const testPage = router.options.routes.find((e) => e.name === "product-page");
          if (testPage != null) {
            route = {
              name: "product-" + lang + "-" + path.replace("/", "-"),
              path: to.path,
              component: testPage.component,
            };
          }
          break;
        }
        case "CMS_PAGE": {
          const testPage = router.options.routes.find((e) => e.name === "cms-page");
          if (testPage != null) {
            route = {
              name: "cms-" + lang + "-" + path.replace("/", "-"),
              path: to.path,
              component: testPage.component,
            };
          }
          break;
        }
        case "LANDING_PAGE": {
          const testPage = router.options.routes.find((e) => e.name === "landing-page");
          if (testPage != null) {
            route = {
              name: "landing-" + lang + "-" + path.replace("/", "-"),
              path: to.path,
              component: testPage.component,
            };
          }
          break;
        }
      }
      if (route !== false) {
        router.addRoute(route);
        // return next(to.fullPath);
        return next(fullpath);
      }
      return next();
    }
  } else {
    if (store.getters["user/getIsLoggedIn"] == true) {
      if (to.name === "login") {
        return next({
          name: "account",
        });
      } else if (to.name === "create-account") {
        return next({
          name: "account",
        });
      } else if (to.name === "en-login") {
        return next({
          name: "en-account",
        });
      } else if (to.name === "en-create-account") {
        return next({
          name: "en-account",
        });
      }
    } else {
      if (to.name === "account") {
        return next({
          name: "login",
        });
      } else if (to.name === "en-account") {
        return next({
          name: "en-login",
        });
      }
    }
    // the route and component are known and data is available

    return next();
  }
  return next("/page-not-found");
}